import { render, staticRenderFns } from "./JCheckBox.vue?vue&type=template&id=d72bf7fe&"
import script from "./JCheckBox.vue?vue&type=script&lang=js&"
export * from "./JCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./JCheckBox.vue?vue&type=style&index=0&id=d72bf7fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports